<template>
  <v-container fluid class="grey800 px-6 py-6">
    <v-overlay absolute :value="loading">
      <v-progress-circular indeterminate />
    </v-overlay>
    <div class="text-center mb-4">
      <h5 class="text-h6 text-uppercase font-weight-bold green500--text">
        Claim rewards
      </h5>
      <p class="text-body-2 green100--text">
        These rewards are exclusive to your account. <br> Claim them before they expire!
      </p>
    </div>

    <div v-if="claimableRewards.length" class="grid-container">
      <v-card
        v-for="reward in claimableRewards" :key="reward._id" tile color="grey600"
        class="reward d-flex flex-column align-center pa-4"
      >
        <component
          :is="reward.component"
          :reward="reward"
          :itemdb="itemdb"
          class="reward-content flex-grow-1"
        />

        <div v-if="reward.expiresAt" class="reward-expiration">
          <v-tooltip top color="primary500" content-class="rounded-0">
            <template #activator="{on}">
              <h4 class="text--secondary text-caption" v-on="on">
                Expires {{ reward.expiresAt | relativeTime('twitter') }}
              </h4>
            </template>
            <span>{{ reward.expiresAt | toDateFormat('YYYY-MM-DD HH:mm:ss') }}</span>
          </v-tooltip>
        </div>


        <v-btn
          color="green700 green100--text" class="flex-grow-0 px-6 mt-3"
          tile small :ripple="false" blosck
          @click="onClaim(reward)"
        >
          Claim
        </v-btn>
      </v-card>
    </div>
    <p v-else class="text-center text--disabled my-12">
      No rewards found
    </p>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

const CLAIMABLE_TYPES = ['scrap', 'items']
const COMPS = {
  scrap: () => import('@/components/UserRewardScrap'),
  items: () => import('@/components/UserRewardItems'),
}

export default {
  props: {
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/session',
      rewards: 'user/rewards',
      itemdb: 'items/items',
    }),
    claimableRewards() {
      return this.rewards
        .filter(i => CLAIMABLE_TYPES.includes(i.type))
        .map(i => ({ ...i, component: COMPS[i.type] }))
    },
  },
  created() {
    this.getRewards()
  },
  methods: {
    ...mapActions({
      getRewards: 'user/getUserRewards',
      claimReward: 'user/claimUserReward',
    }),
    async onClaim(reward) {
      if (this.loading) return
      this.loading = true

      try {
        await this.claimReward(reward._id)
        this.$toast.success('Reward claimed successfully')
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        this.loading = false
      }
    },
  },
}

</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  position: relative;
  grid-template-columns: repeat(auto-fit, minmax(164px, 1fr));
  grid-gap: 16px;

  .reward {
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-3px);
    }
  }
}
</style>
